import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core';
import UserAvatar from '../../../../userAvatar';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  notAccessible: {
    color: primary.bluish5,
    cursor: 'default',
  },
  root: {
    marginLeft: spacing(1.5),
    maxWidth: 180,
  },
  label: {
    fontFamily: 'ProximaNova-Bold',
    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 'normal',
    letterSpacing: 'normal',
    textTransform: 'none',
  },
}));

const MeetingModerator = ({
  meeting,
  canAccessUserProfileCheck,
  onClickHandler,
}) => {
  const classes = useStyles();
  const { moderator } = meeting;
  const isEmployeeClickable = canAccessUserProfileCheck(moderator?.id);

  const handleClick = e => {
    e.stopPropagation();
    onClickHandler(moderator.id);
  };

  return (
    <UserAvatar
      className={classes.root}
      labelClass={classNames(classes.label, {
        [classes.notAccessible]: !isEmployeeClickable,
      })}
      user={moderator}
      clickableCaption={isEmployeeClickable}
      caption
      extraSmall
      onClickHandler={handleClick}
    />
  );
};

MeetingModerator.propTypes = {
  meeting: PropTypes.object.isRequired,
  canAccessUserProfileCheck: PropTypes.func.isRequired,
};

export default MeetingModerator;
